module.exports = __webpack_public_path__ + "static/media/trending.0c411949.png";